import React from 'react';
import { createMergingContextProvider } from '@wix/da-react-context/pkg/helpers';
import { BiContextAllowedProps } from './events';

const BiContext = React.createContext<BiContextAllowedProps>({});
BiContext.displayName = 'BiContext';

const BiLoggerContextConsumer = BiContext.Consumer;

export interface PropsProvider {
  children?: React.ReactNode | undefined;
  value: BiContextAllowedProps;
}

/**
 * Merge context for nested providers
 */
const BiLoggerContextProvider: React.FC<PropsProvider> = createMergingContextProvider(
  BiContext,
  'BiLoggerContextProvider'
);

export { BiLoggerContextProvider, BiLoggerContextConsumer, BiContext };
